(function () {
  if (window.Shopify && Shopify.designMode) return;
  if (window.__tgdGa4LeadTrackingInstalled) return;
  window.__tgdGa4LeadTrackingInstalled = true;

  function sendEvent(name, params) {
    params = params || {};
    params.page_location = window.location.href;
    params.page_path = window.location.pathname + window.location.search;
    params.event_source = 'tgd_lead_tracking';

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params));
  }

  function textOf(el) {
    return ((el && (el.innerText || el.textContent)) || '').replace(/\s+/g, ' ').trim().slice(0, 160);
  }

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  document.addEventListener('click', function (event) {
    var link = closest(event.target, 'a[href]');
    var button = closest(event.target, 'button, [role="button"], .storeify-quote-btn-trigger-popup, [data-target*="quote"], [class*="quote"]');

    if (link) {
      var href = link.getAttribute('href') || '';
      var hrefLower = href.toLowerCase();
      var label = textOf(link);

      if (hrefLower.indexOf('tel:') === 0) {
        sendEvent('phone_click', { link_url: href, link_text: label });
      } else if (hrefLower.indexOf('mailto:') === 0) {
        sendEvent('email_click', { link_url: href, link_text: label });
      } else if (hrefLower.indexOf('docs.google.com/forms') !== -1) {
        sendEvent('quote_request_click', { link_url: href, link_text: label, quote_source: 'google_form' });
        sendEvent('generate_lead', { lead_type: 'quote_request', lead_source: 'google_form' });
      }
    }

    if (button) {
      var buttonLabel = textOf(button);
      var classes = String(button.className || '');
      var target = button.getAttribute('data-target') || '';
      var productHandle = button.getAttribute('data-product') || '';
      var looksLikeQuote = /request\s*a\s*quote|get\s*quote|quote/i.test(buttonLabel + ' ' + classes + ' ' + target);

      if (looksLikeQuote) {
        sendEvent('quote_request_click', {
          link_text: buttonLabel || 'Request a Quote',
          product_handle: productHandle,
          quote_source: productHandle ? 'storeify_quote_button' : 'site_button'
        });
        sendEvent('generate_lead', {
          lead_type: 'quote_request',
          lead_source: productHandle ? 'storeify_quote_button' : 'site_button',
          product_handle: productHandle
        });
      }
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches) return;

    var id = form.getAttribute('id') || '';
    var action = form.getAttribute('action') || '';
    var formTypeField = form.querySelector('[name="form_type"]');
    var formType = formTypeField ? formTypeField.value : '';
    var isContactForm = id === 'ContactForm' || action.indexOf('/contact') !== -1 || formType === 'contact';

    if (isContactForm) {
      sendEvent('form_submit', { form_id: id || 'contact_form', form_type: formType || 'contact' });
      sendEvent('generate_lead', { lead_type: 'contact_form', form_id: id || 'contact_form' });
    }
  }, true);
})();
